export default __webpack_public_path__ + "static/media/webplatform.2e08d534.svg";